import { config } from '@/config';

const PreviewMail = ({
  template,
  courseId,
  create,
  lvCustomMail,
  reminderEmail,
}: any) => {
  return (
    <>
      <iframe
        style={{
          border: '0',
          width: '100%',
          height: '100%',
          minHeight: '70vh',
        }}
        src={
          create
            ? `${
                config.backend
              }/contact/templatecontent/${template}/${courseId}?${
                reminderEmail
                  ? 'reminderEmail=' + encodeURIComponent(reminderEmail)
                  : 'lvCustomMail=' + encodeURIComponent(lvCustomMail)
              }`
            : `${config.backend}/contact/template/${template}/${courseId}`
        }
      ></iframe>
    </>
  );
};

export default PreviewMail;
